import { FormField, FormSelect } from "@/components/Drawer";
import useMaster from "@/hooks/useMaster";
import { EMPTY_EXCHANGE } from "@/lib/constants";

export default function ExchangeBlock({ value, onChange }) {
  const { items: evaluators } = useMaster("/evaluators");
  const v = value || EMPTY_EXCHANGE;
  const set = (k, val) => onChange({ ...v, [k]: val });
  const evaluatorOptions = [
    { value: "", label: "— Select evaluator —" },
    ...evaluators.map((e) => ({ value: e.id, label: e.name })),
  ];
  return (
    <div className="border border-canvas-line p-3 space-y-3" data-testid="exchange-block">
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted">
        Exchange Vehicle
      </div>
      <div>
        <FormField
          label="Vehicle Description"
          value={v.description || ""}
          onChange={(x) => set("description", x)}
          testId="exchange-description"
          placeholder="e.g. Honda Activa 5G 2018 Silver"
        />
      </div>
      <div className="grid grid-cols-3 gap-3">
        <FormField
          label="Year"
          type="number"
          value={v.year}
          onChange={(x) => set("year", x)}
          testId="exchange-year"
        />
        <FormField
          label="Registration No"
          value={v.registration_no}
          onChange={(x) => set("registration_no", x)}
          testId="exchange-regno"
        />
        <FormField
          label="Colour"
          value={v.color}
          onChange={(x) => set("color", x)}
          testId="exchange-color"
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <FormField
          label="Exchange Amount (₹)"
          type="number"
          value={v.amount}
          onChange={(x) => set("amount", Number(x) || 0)}
          testId="exchange-amount"
        />
        <FormSelect
          label="Responsible Evaluator"
          value={v.evaluator_id}
          onChange={(x) => set("evaluator_id", x)}
          options={evaluatorOptions}
          testId="exchange-evaluator"
        />
      </div>
    </div>
  );
}
